export default {
  getStateName(status, publishable) {
    if (status === "published") {
      return "published";
    } else if (status === "draft" && publishable === true) {
      return "ready";
    } else {
      return "draft";
    }
  },

  getVariant: function (stateName) {
    switch (stateName) {
      case "published":
        return "accent";

      case "ready":
        return "success";

      case "draft":
        return "danger";
    }
  },

  formatDate: function (date) {
    const currentDate = new Date();
    const sevenDaysInMiliseconds = 604800000;
    const diffInMiliseconds = this.$moment(
      currentDate,
      "YYYY-MM-DD'T'HH:mm:ss:SSSZ"
    ).diff(this.$moment(date, "YYYY-MM-DD'T'HH:mm:ss:SSSZ"));

    if (diffInMiliseconds < sevenDaysInMiliseconds) {
      return this.$moment(date).fromNow();
    } else {
      return this.$moment(date).format("ll");
    }
  },

  sortLayersByGroups: function (layers, groups) {
    const _ = this.$lodash;

    const results = _.filter(layers, function (layer) {
      if ((layer.layer_products_count || 0) > 0) {
        return _.includes(groups, layer.group);
      }
    });

    return _.sortBy(results, "sequence");
  },

  // ----------------------------------------------------------------------------------
  // TODO: This mapper is only temporary. This naming needs to be consolidated between
  // Layers and wardrobe products. [2018/11/24 - Paris]
  // ----------------------------------------------------------------------------------
  getGroupName(displayName) {
    const name = displayName.toLowerCase();

    if (name === "coats & jackets") {
      return "outerwear";
    } else if (name === "knitwear & light jackets") {
      return "midwear";
    } else if (name === "shirts & t-shirts") {
      return "innerwear";
    } else if (name === "shorts & trousers") {
      return "bottoms";
    } else if (name === "footwear") {
      return "footwear";
    } else if (
      name === "accessories 1" ||
      name === "accessories 2"
    ) {
      return "accessories";
    }
  },

  // TODO: This mapper is only temporary. This naming needs to be consolidated between
  // Layers and wardrobe products. [2020/04/19 - Paris]
  getDisplayName(groupName) {
    const name = groupName.toLowerCase();

    if (name === "outerwear") {
      return "coats & jackets";
    } else if (name === "midwear") {
      return "knitwear & light jackets";
    } else if (name === "innerwear") {
      return "shirts & t-shirts";
    } else if (name === "bottoms") {
      return "shorts & trousers";
    } else if (name === "footwear") {
      return "footwear";
    } else if (name === "accessories") {
      return "accessories";
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/CapsuleUtils.js